import Messages from '@/components/SystemMessages/Messages';

export default Messages;
